import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/gerelt/front/app/providers.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/gerelt/front/components/Footer.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/gerelt/front/components/Header.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/gerelt/front/components/MobileFooterMenu.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/gerelt/front/components/Topbar.js");
;
import(/* webpackMode: "eager" */ "/var/www/gerelt/front/node_modules/bootstrap/dist/css/bootstrap.css");
;
import(/* webpackMode: "eager" */ "/var/www/gerelt/front/node_modules/antd/dist/reset.css");
;
import(/* webpackMode: "eager" */ "/var/www/gerelt/front/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/var/www/gerelt/front/styles/fonts.css");
;
import(/* webpackMode: "eager" */ "/var/www/gerelt/front/styles/global.css");
;
import(/* webpackMode: "eager" */ "/var/www/gerelt/front/node_modules/react-toastify/dist/ReactToastify.css");
;
import(/* webpackMode: "eager" */ "/var/www/gerelt/front/node_modules/react-image-gallery/styles/css/image-gallery.css");
;
import(/* webpackMode: "eager" */ "/var/www/gerelt/front/node_modules/animate.css/animate.css");
